export const PrimeTvStreams = [
    { name: 'Salem', img: 'salem.png' },
    { name: 'KINOROOM', img: 'kinoroom.png' },
    // { name: 'Amediateka', img: 'amediateka.png' },
    { name: 'Megogo', img: 'megogo.png' },
    { name: 'WINK', img: 'wink.png' },
    { name: 'Premier', img: 'premier.png' },
    { name: 'Qazaqsha', img: 'qazaqsha.png' },
    { name: 'Start', img: 'start.png' },
    { name: 'Viju', img: 'viju.png' },
];
